import React from 'react';
import {
    ACTION_DOWN, ACTION_DOWN_LEFT, ACTION_DOWN_RIGHT,
    ACTION_LEFT, ACTION_RELAX, ACTION_RIGHT,
    ACTION_UP, ACTION_UP_LEFT, ACTION_UP_RIGHT,
    ACTION_CENTER
} from "../../tools/EyeActions";
import { getAvatarState } from "./avatarUtils";

const pupilOffsets = {
    [ACTION_LEFT]:       { x: -9, y: 0 },
    [ACTION_RIGHT]:      { x: 9, y: 0 },
    [ACTION_UP]:         { x: 0, y: -9 },
    [ACTION_DOWN]:       { x: 0, y: 9 },
    [ACTION_UP_LEFT]:    { x: -6, y: -6 },
    [ACTION_UP_RIGHT]:   { x: 6, y: -6 },
    [ACTION_DOWN_LEFT]:  { x: -6, y: 6 },
    [ACTION_DOWN_RIGHT]: { x: 6, y: 6 },
    [ACTION_CENTER]:     { x: 0, y: 0 },
    [ACTION_RELAX]:      { x: 0, y: 0 },
};

class OwlAvatar extends React.Component {
    render() {
        const { offset, isRelax, containerSize, isBlink, pulseClass } = getAvatarState(this.props, pupilOffsets);

        return (
            <div className="avatar-holder" style={{ width: containerSize, height: containerSize * 0.75 }}>
                <svg viewBox="-3 -3 206 156" className="avatar-svg">
                    {/* Ear tufts */}
                    <polygon points="55,25 42,0 68,18" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.5" />
                    <polygon points="145,25 158,0 132,18" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.5" />
                    <polygon points="55,25 46,8 64,20" fill="var(--avatar-secondary)" />
                    <polygon points="145,25 154,8 136,20" fill="var(--avatar-secondary)" />

                    {/* Body & wings */}
                    <ellipse cx="100" cy="115" rx="45" ry="30" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2" />
                    <ellipse cx="100" cy="118" rx="28" ry="22" fill="var(--avatar-secondary)" opacity="0.5" />
                    <ellipse cx="52" cy="105" rx="18" ry="30" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.5" transform="rotate(-10 52 105)" />
                    <ellipse cx="148" cy="105" rx="18" ry="30" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.5" transform="rotate(10 148 105)" />

                    {/* Head */}
                    <ellipse cx="100" cy="62" rx="55" ry="45" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2" />
                    <ellipse cx="100" cy="65" rx="45" ry="38" fill="var(--avatar-secondary)" opacity="0.35" />

                    {/* Eye rings */}
                    <circle cx="75" cy="58" r="22" fill="var(--avatar-eye-ring)" stroke="var(--avatar-outline)" strokeWidth="1.5" />
                    <circle cx="125" cy="58" r="22" fill="var(--avatar-eye-ring)" stroke="var(--avatar-outline)" strokeWidth="1.5" />

                    {/* Eyes */}
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '75px 58px' }}>
                        <circle cx="75" cy="58" r={isRelax ? 3 : 17} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1" style={{ transition: 'r 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={75 + offset.x} cy={58 + offset.y} r="9" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={75 + offset.x - 3} cy={58 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '125px 58px' }}>
                        <circle cx="125" cy="58" r={isRelax ? 3 : 17} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1" style={{ transition: 'r 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={125 + offset.x} cy={58 + offset.y} r="9" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={125 + offset.x - 3} cy={58 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>

                    {/* Beak & feet */}
                    <polygon points="100,72 94,82 106,82" fill="var(--avatar-beak)" stroke="var(--avatar-outline)" strokeWidth="1.5" strokeLinejoin="round" />
                    <g fill="var(--avatar-beak)" stroke="var(--avatar-outline)" strokeWidth="1">
                        <path d="M82 140 L78 148 M82 140 L82 149 M82 140 L86 148" strokeLinecap="round" />
                        <path d="M118 140 L114 148 M118 140 L118 149 M118 140 L122 148" strokeLinecap="round" />
                    </g>
                </svg>
            </div>
        );
    }
}

export default OwlAvatar;
